/* eslint-disable indent */
import React, { Fragment } from "react";
import PropTypes from "prop-types";

import SelectInput2 from "../../../component/input/SelectInput2";
import TextInput2 from "../../../component/input/TextInput2";
import {
  isSuperAdmin,
  locationRender,
  renderAccessLocation2,
  renderLocationFunction
} from "../../../constant/helper/helper";
import SpinnerButton from "../../../component/spinner/SpinnerButton";
import Button from "../../../component/button/Button";
import RenderToolTip from "../../../component/tooltip/RenderToolTip";
import { toolTipData } from "./attendanceStaticData";

const TopInput = ({
  values,
  loading,
  onSubmit,
  onChange,
  allLocations,
  currentUser
}) => {
  return (
    <Fragment>
      <div className="row">
        <RenderToolTip toolTipData={toolTipData} />
        <div className="col-lg-2 col-md-2 col-sm-12">
          <TextInput2
            data-tip
            type="date"
            name="date"
            data-for="date"
            onChange={onChange}
            value={values.date}
            placeholder="Select Date"
            icon="mdi mdi-calendar-check"
          />
        </div>
        <div className="col-lg-2 col-md-2 col-sm-12">
          <SelectInput2
            data-tip
            name="dataType"
            isLabeled={true}
            onChange={onChange}
            data-for="dataType"
            label="Select Type"
            value={values.dataType}
            placeholder="Select Location"
            icon="mdi mdi-map-marker-radius"
          >
            <option value="">Select Type</option>
            <option value="ALL">ALL Locations</option>
            <option value="SPECIFIC">Specific Locations</option>
          </SelectInput2>
        </div>
        {values.dataType !== "ALL" && (
          <div className="col-lg-3 col-md-3 col-sm-12">
            <SelectInput2
              data-tip
              name="locationId"
              isLabeled={true}
              onChange={onChange}
              data-for="locationName"
              label="Select Location"
              value={values.locationId}
              placeholder="Select Location"
              icon="mdi mdi-map-marker-radius"
            >
              {isSuperAdmin(currentUser)
                ? renderLocationFunction(allLocations)
                : renderAccessLocation2(
                    locationRender(currentUser, false)
                  )}
            </SelectInput2>
          </div>
        )}
        {loading === true ? (
          <div className="col-sm-2 col-md-2 col-lg-2">
            <SpinnerButton />
          </div>
        ) : (
          <div className="col-sm-2 col-md-2 col-lg-2">
            <div className="form-group">
              <Button
                title="GET"
                type="button"
                onClick={onSubmit}
                isBackgroundColor={false}
                icon="mdi mdi-plus-circle-outline mr-2"
                className="btn mb-2 text-white btn-dark btn-block"
              />
            </div>
          </div>
        )}
        <div className="col-lg-3 col-md-3">
          <TextInput2
            data-tip
            type="text"
            name="Filter"
            data-for="Filter"
            onChange={onChange}
            value={values.Filter}
            icon="mdi mdi-magnify"
            placeholder="Search..."
          />
        </div>
      </div>
    </Fragment>
  );
};

TopInput.propTypes = {
  loading: PropTypes.bool.isRequired,
  values: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  currentUser: PropTypes.object.isRequired,
  allLocations: PropTypes.array.isRequired
};

export default TopInput;
